import commonLangs from './common'
import {getCookie, getLang} from '../common/utils'
const VALID_LANG = ['cn', 'hk']

class Lang {
    constructor(langData){
        this.data = langData
        this.language = this._getLanguage()
        this.currData = this._getCurrData()
    }

    // cookie,lang属性判断语言
    // _getLanguage(){
    //     let browserLang = getCookie('lang') || 'cn'
    //     let lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang
    //     console.log(lang)
    //     return lang
    // }

    //根据url来判断语言
    _getLanguage(){
        let browserLang = getLang();//menu.js里定义的变量
        let lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang
        // console.log('18lang: '+lang);
        return lang
    }

    _getCurrData(){
        let localLang = this.data[this.language] || {}
        let commonLang = commonLangs[this.language] || {}
        return Object.assign({}, commonLang, localLang)
    }

    getText(key, params={}){
        let text = this.currData[key] || ''
        if(typeof(text) == 'string' || typeof(text) == 'number'){
            for(let i in params){
                text = text.replace(`:${i}`, params[i])
            }
        }
        return text
    }
}

module.exports = Lang



// WEBPACK FOOTER //
// ./js/src/i18n/Lang.js